import TabViewModel from "Lib/Fs.SmartClient.Client/TabViewModel";
import { computedFrom, autoinject } from 'aurelia-framework';
import { BindingEngine } from 'aurelia-binding';
import { Container } from 'aurelia-framework';

@autoinject
export default class EditableContainerBase extends TabViewModel {

    Parent: EditableContainerBase;
    IsFullLoad: boolean = false;
    IsEditing: boolean = false;
    bindingEngine: BindingEngine;
    ErrorList: string[];
    
    HasEditingChilds: boolean = false;
    AllowDelete: boolean = true;
    CanDeleteItem: boolean = false;
    AllowEdit: boolean = false;
    CanEdit: boolean = false;
    
    CanEditSubscribe: any;
    HasEditingChildsSubscribe: any;
    Id: string;

    constructor() {
        super();
        this.bindingEngine = Container.instance.get(BindingEngine);
    }

    SetIsEditing(isEditing: boolean) {
        this.IsEditing = isEditing;
        this.CalculateHasEditingChilds();
    };

    CalculateCanEdit() {
        if (!this.AllowEdit)
            this.CanEdit = false;
        else if (this.Parent != null)
            this.CanEdit = this.Parent.CanEdit;
        else
            this.CanEdit = this.AllowEdit;
    };

    CalculateHasEditingChilds() {
        if (this.IsEditing) {
            this.HasEditingChilds = true;
        }
        else {
            this.HasEditingChilds = this.CheckEditingChilds();
        }
    };

    CheckEditingChilds() {
        var keys = Object.keys(this.ChildNodeGroups);
        for (var index = 0; index < keys.length; index++) {
            var childNodes = this.ChildNodeGroups[keys[index]];
            for (var c_index = 0; c_index < childNodes.length; c_index++) {
                var child = childNodes[c_index];
                if (child == null) continue;
                if (child.HasEditingChilds != null && child.HasEditingChilds)
                    return true;
            }
        }
        return false;
    };

    PrepareChildVMs() {
    };

    FullLoad() {
        this.ClearChildNode();
        this.PrepareChildVMs();
        if (this.ChildVMsPreparing != null)
            this.ChildVMsPreparing(this, null);

        this.IsFullLoad = true;
    };

    Activate() {
        if (!this.IsFullLoad)
            this.FullLoad();
    };

    ChildVMsPreparing(sender, e) {

    };

    OnParentPropertyChanged(args) {
        this.CalculateCanEdit();
    };

    AddChildNode(node, groupName = null) {
        if (groupName == null)
            groupName = "default";

        super.AddChildNode(node, groupName);

        var self = this;

        node.HasEditingChildsSubscribe = this.bindingEngine.propertyObserver(node, 'HasEditingChilds')
            .subscribe((newValue, oldValue) => {
                self.CalculateHasEditingChilds();
                self.CanDeleteItem = !self.HasEditingChilds;
            });

        node.CanEditSubscribe = this.bindingEngine.propertyObserver(node, 'CanEdit')
            .subscribe((newValue, oldValue) => {
            });

        node.Parent = self;
        self.CanEditSubscribe = this.bindingEngine.propertyObserver(this, 'CanEdit')
            .subscribe(node.OnParentPropertyChanged);

        if (node.CalculateCanEdit)
            node.CalculateCanEdit();
    };

    RemoveChildNode(node, groupName) {
        if (groupName == null)
            groupName = "default";

        super.RemoveChildNode(node);

        if (node.HasEditingChildsSubscribe != null)
            node.HasEditingChildsSubscribe.dispose();

        if (node.CanEditSubscribe != null)
            node.CanEditSubscribe.dispose();
    }
}